//SelectIdTitleNodeDialog
//***********************************************************************************************************************
import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Dialog, IDialogButton } from "../framework/dialog";
import { DialogButtonType } from "ui/Scripts/source/models/enums";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

//SelectIdTitleNodeDialogLine
export interface ISelectIdTitleNodeDialogLineProp {
    classes?: string;
    item: IIdTitleNode;
    level: number;
    selectedId: string;
    onNodeClick: (item: IIdTitleNode) => void;
}

export class SelectIdTitleNodeDialogLine extends React.Component<ISelectIdTitleNodeDialogLineProp, {}> {
    handleNodeClick = (e) => {
        this.props.onNodeClick(this.props.item);
    };

    render() {
        const props = this.props;
        const item = props.item;
        const hasChildren = item.children.length > 0;
        return (
            <ul>
                <li className={"expanded" + (!hasChildren ? " noChilds" : "") + (props.level < 1 ? " root" : "") + (!item.active ? " subTitle" : "") + (props.selectedId === item.id ? " selected" : "")} onClick={this.handleNodeClick}>
                    <span className={"node" + (!hasChildren ? " empty" : "")}></span>
                    <span className="name">{item.title}</span>
                </li>
                {item.children.map(child => (
                    <SelectIdTitleNodeDialogLine
                        key={child.id}
                        item={child}
                        level={props.level + 1}
                        selectedId={props.selectedId}
                        onNodeClick={props.onNodeClick}
                    />
                ))}
            </ul>
        );
    }
}

//SelectIdTitleNodeDialog
export interface ISelectIdTitleNodeDialogProp {
    classes?: string;
    nextPreviousMode?: boolean;
    values: IIdTitleNode[];
    selectedId: string;
    title: string;
    onOk: (id: string) => void;
    onCancel: () => void;
    onPrevious?: () => void;
}

export interface ISelectIdTitleNodeDialogState {
    selectedId: string;
}

export class SelectIdTitleNodeDialog extends React.Component<ISelectIdTitleNodeDialogProp, ISelectIdTitleNodeDialogState> {
    constructor(props) {
        super(props);
        this.state = { selectedId: props.selectedId };
    }

    handleNodeClick = (item: IIdTitleNode) => {
        if (!item) return;
        const disabled = !item.active;
        if (disabled) return;
        this.props.onOk(item.id);
    };

    handleOkClick = () => {
        const selectedId = this.state.selectedId;
        const value = IdTitleNode.getById(this.props.values, selectedId);
        if (!value) {
            this.props.onOk("");
        } else {
            this.props.onOk(value.id);
        }
    };

    render() {
        const props = this.props;
        const state = this.state;
        const dialogClasses = "selectIdTitleNodeDialog" + (props.classes ? " " + props.classes : "");
        const buttons: IDialogButton[] = [];
        if (props.nextPreviousMode) {
            if (props.onPrevious) {
                buttons.push({ title: Translations.Previous, buttonType: DialogButtonType.Default, onClick: props.onPrevious });
            }
            if (props.onOk) {
                buttons.push({ title: Translations.Next, buttonType: DialogButtonType.Default, onClick: this.handleOkClick });
            }
        } else {
            buttons.push({ title: Translations.Cancel, buttonType: DialogButtonType.Default, onClick: props.onCancel });
        }
        return (
            <Dialog
                classes={dialogClasses}
                title={props.title}
                body={
                    <div className="largeDialogContent">
                        <div className="nodeTree eventTypeTree withPadding">
                            {props.values.map(value => (
                                <SelectIdTitleNodeDialogLine
                                    key={value.id}
                                    item={value}
                                    level={0}
                                    selectedId={state.selectedId}
                                    onNodeClick={this.handleNodeClick}
                                />
                            ))}
                        </div>
                    </div>
                }
                buttons={buttons}
                onClose={props.onCancel}/>
        );
    }
}